import React from 'react';
import SEO from '../components/SEO';
import ProgressiveBackground from '../components/ProgressiveBackground';

const Main: React.FC = () => {
    const text = `Здравствуйте!

Меня зовут Ольга, я медицинский психолог. С самых ранних лет я знала, что хочу помогать людям, и потому выбрала психологию своим профессиональным путем.

Я получила образование в области медицинской психологии, а затем продолжила обучение, осваивая различные подходы когнитивно-поведенческую терапию, гештальт, кризисное вмешательство и психоонкологию. В своей работе я использую интегративный метод, подбирая техники в зависимости от потребностей человека.

Сейчас я работаю в одной из ведущих больниц Израиля, оказывая психологическую поддержку пациентам в онкологическом и иммунологическом отделениях. В последние годы моя практика все больше сосредоточена на психоонкологии эта тема стала для меня не только профессиональной, но и личной. Я знаю, что значит столкнуться с онкологическим диагнозом, и понимаю, насколько важно в этот период получить поддержку.

Если вам нужна помощь, я буду рада быть рядом. Давайте вместе найдём путь к равновесию и внутреннему ресурсу.
    `

    return (
        <>
            <SEO
                title="Медицинский психолог Ольга Гальперина | Онлайн консультации"
                description="Онлайн консультации с профессиональным медицинским психологом. КПТ терапия, психоонкология, кризисное вмешательство. Индивидуальные и семейные консультации."
                keywords="онлайн психолог, кпт психолог, психоонкология, медицинский психолог, психологическая помощь онлайн"
                canonical="/"
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "MedicalWebPage",
                    "name": "Медицинский психолог Ольга Гальперина",
                    "description": "Онлайн консультации с профессиональным медицинским психологом. КПТ терапия, психоонкология, кризисное вмешательство.",
                    "provider": {
                        "@type": "Person",
                        "name": "Ольга Гальперина",
                        "jobTitle": "Медицинский психолог",
                        "image": "https://olgagalperina.com/logo192.png"
                    },
                    "audience": {
                        "@type": "MedicalAudience",
                        "audienceType": "Пациенты с онкологическими заболеваниями, люди в кризисных ситуациях"
                    }
                }}
            />
            <div className="main-content-container">
                <div className="page-header">Главная</div>
                <div className="main-content">
                    <div className="image-wrapper image-wrapper-left">
                        <ProgressiveBackground
                            imageName="main-page"
                            className="main-image-left"
                            ariaLabel="Медицинский психолог, онлайн консультации"
                        />
                    </div>
                    <div className="divider-container ">
                        <div className="divider"></div>
                    </div>
                    <div className="main-content-area main-content-area-right">
                        <div className="main-content-text">{text}</div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Main;
